/* ==========================================================================
   MY QAMIS HOMME - Panier

   1. Ouvre le tiroir apres l'ajout d'une box (/?panier=ouvert)
   2. Retire les options dont le produit parent a ete supprime

   Le verrouillage visuel des lignes d'options est gere en Liquid dans
   snippets/cart-products.liquid : plus fiable, car cote serveur.

   --------------------------------------------------------------------------
   SECURITE DES SUPPRESSIONS (correctif)

   Le nettoyage des options orphelines est une operation DESTRUCTIVE et
   IRREVERSIBLE : une ligne supprimee a tort n'est jamais refacturee, et le
   client part au checkout avec ses options gratuites.

   Shopify ne garantit AUCUNE isolation entre requetes panier concurrentes
   d'une meme session. Pendant qu'un /cart/add.js ecrit un lot atomique
   (produit + ses options), un /cart.js parallele peut lire un etat
   intermediaire ou l'option existe deja mais pas encore son parent. Sur cet
   instantane, l'option est declaree orpheline et detruite. L'ajout se
   termine ensuite normalement : le parent est la, l'option a disparu.

   Trois verrous rendent ce scenario impossible :

     1. ECRITURES EN VOL - window.fetch est instrumente. Tant qu'une ecriture
        panier est en cours, ou dans les DELAI_APRES_ECRITURE qui suivent la
        derniere, aucune suppression n'est envisagee. Couvre mqh-perso.js, le
        module cadeau, l'upsell du tiroir et Horizon lui-meme, sans qu'aucun
        de ces fichiers ait a etre modifie.

     2. DOUBLE CONFIRMATION - une orpheline doit etre observee sur DEUX
        lectures /cart.js distinctes, espacees d'au moins DELAI_CONFIRMATION.
        Un etat transitoire ne survit jamais a cette double vue.

     3. VERIFICATION FINALE ET PLAFOND - une derniere lecture juste avant
        d'envoyer les suppressions, et jamais plus de PLAFOND_SUPPRESSION
        lignes en une passe.

   En cas de doute, ce fichier ne supprime rien : une option non facturee
   rattrapee a la main coute infiniment moins cher qu'une ligne detruite.
   ========================================================================== */

(function () {
  'use strict';

  if (window.__mqhCartBox) return;
  window.__mqhCartBox = true;

  /* Silence observe apres la derniere ecriture panier avant de juger. */
  var DELAI_APRES_ECRITURE = 2000;

  /* Ecart minimal entre les deux observations d'une meme orpheline. */
  var DELAI_CONFIRMATION = 1500;

  /* Au-dela, on considere que quelque chose ne va pas et on s'abstient. */
  var PLAFOND_SUPPRESSION = 12;

  /* Garde anti-rebond entre deux passages complets. */
  var DELAI_ENTRE_PASSAGES = 800;

  var enCours = false;
  var dernierPassage = 0;
  var passeProgrammee = null;

  /* cle de ligne -> horodatage de la premiere observation en orpheline */
  var suspectes = {};

  /* ==========================================================
     1. Surveillance des ecritures panier
     ========================================================== */

  var ecrituresEnVol = 0;
  var derniereEcriture = 0;

  (function surveillerEcritures() {
    if (!window.fetch || window.__mqhFetchSurveille) return;
    window.__mqhFetchSurveille = true;

    var natif = window.fetch;

    window.fetch = function (entree, options) {
      var url = '';
      try {
        if (typeof entree === 'string') {
          url = entree;
        } else if (entree && typeof entree.url === 'string') {
          url = entree.url;
        }
      } catch (e) {}

      if (!/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        return natif.apply(this, arguments);
      }

      ecrituresEnVol++;
      derniereEcriture = Date.now();

      /* Toute ecriture invalide les soupcons en cours : le panier
         d'apres n'est plus celui sur lequel ils ont ete formes. */
      suspectes = {};

      function fin() {
        ecrituresEnVol = Math.max(0, ecrituresEnVol - 1);
        derniereEcriture = Date.now();
      }

      return natif.apply(this, arguments).then(
        function (reponse) { fin(); return reponse; },
        function (erreur) { fin(); throw erreur; }
      );
    };
  })();

  function ecritureRecente() {
    if (ecrituresEnVol > 0) return true;
    return Date.now() - derniereEcriture < DELAI_APRES_ECRITURE;
  }

  /* ==========================================================
     Ouverture du tiroir
     ========================================================== */

  function demandeOuverture() {
    try {
      return new URLSearchParams(window.location.search).get('panier') === 'ouvert';
    } catch (e) {
      return window.location.search.indexOf('panier=ouvert') !== -1;
    }
  }

  function nettoyerUrl() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('panier');
      history.replaceState(null, '', url.pathname + url.search + url.hash);
    } catch (e) {}
  }

  function ouvrir(drawer) {
    if (typeof drawer.open === 'function') { drawer.open(); return true; }
    if (typeof drawer.showDialog === 'function') { drawer.showDialog(); return true; }
    var dlg = drawer.querySelector('dialog');
    if (dlg && typeof dlg.showModal === 'function') { dlg.showModal(); return true; }
    var bouton = drawer.querySelector('[data-testid="cart-drawer-trigger"]') || drawer.querySelector('button');
    if (bouton) { bouton.click(); return true; }
    return false;
  }

  function essayerOuvrir(tentative) {
    tentative = tentative || 0;
    var drawer = document.querySelector('cart-drawer-component');
    if (drawer && ouvrir(drawer)) { nettoyerUrl(); return; }
    if (tentative < 30) {
      setTimeout(function () { essayerOuvrir(tentative + 1); }, 120);
      return;
    }
    nettoyerUrl();
  }

  /* ==========================================================
     Lecture du panier et detection des orphelines
     ========================================================== */

  function lirePanier() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (r) {
      if (!r.ok) throw new Error('lecture panier');
      return r.json();
    });
  }

  function trouverOrphelines(cart) {
    var parents = {};
    var items = (cart && cart.items) || [];

    for (var i = 0; i < items.length; i++) {
      var ligne = items[i].properties && items[i].properties._box_ligne;
      if (ligne) parents[ligne] = true;
    }

    var aRetirer = [];
    for (var j = 0; j < items.length; j++) {
      var pere = items[j].properties && items[j].properties._box_parent;
      if (pere && !parents[pere]) aRetirer.push(items[j].key);
    }
    return aRetirer;
  }

  function retirer(cles) {
    var suite = Promise.resolve();
    cles.forEach(function (cle) {
      suite = suite.then(function () {
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: cle, quantity: 0 })
        });
      });
    });
    return suite;
  }

  /* ==========================================================
     Redessin du panier
     Les noms de sections sont lus dans la page elle-meme
     (id="shopify-section-xxx"), jamais devines.
     ========================================================== */

  function sectionsDuPanier() {
    var trouvees = [];
    var hotes = document.querySelectorAll('cart-drawer-component, cart-items-component');

    for (var i = 0; i < hotes.length; i++) {
      var section = hotes[i].closest('[id^="shopify-section-"]');
      if (!section) continue;

      var nom = section.id.replace('shopify-section-', '');
      var deja = false;
      for (var j = 0; j < trouvees.length; j++) {
        if (trouvees[j].nom === nom) deja = true;
      }
      if (!deja) trouvees.push({ nom: nom, id: section.id });
    }
    return trouvees;
  }

  function rafraichir() {
    var sections = sectionsDuPanier();

    /* la page n'affiche pas le panier : rien a redessiner */
    if (!sections.length) {
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true }));
      return Promise.resolve(true);
    }

    var noms = [];
    for (var i = 0; i < sections.length; i++) noms.push(sections[i].nom);

    return fetch('/?sections=' + encodeURIComponent(noms.join(',')), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function (r) { return r.json(); })
      .then(function (rendus) {
        var remplace = false;

        for (var i = 0; i < sections.length; i++) {
          var html = rendus[sections[i].nom];
          var hote = document.getElementById(sections[i].id);
          if (!html || !hote) continue;

          var doc = new DOMParser().parseFromString(html, 'text/html');
          var frais = doc.getElementById(sections[i].id) || doc.body.firstElementChild;
          if (!frais) continue;

          hote.innerHTML = frais.innerHTML;
          remplace = true;
        }

        if (remplace) {
          ['cart:update', 'cart:refresh'].forEach(function (nom) {
            document.dispatchEvent(new CustomEvent(nom, {
              bubbles: true,
              detail: { source: 'mqh-cart-box' }
            }));
          });
        }
        return remplace;
      })
      .catch(function () { return false; });
  }

  /* ==========================================================
     Passe de verification
     ========================================================== */

  function programmerNouvellePasse(delai) {
    clearTimeout(passeProgrammee);
    passeProgrammee = setTimeout(function () { verifier(); }, delai);
  }

  function verifier() {
    if (enCours) return;

    /* Verrou 1 : jamais de jugement pendant ou juste apres une ecriture. */
    if (ecritureRecente()) {
      programmerNouvellePasse(DELAI_APRES_ECRITURE);
      return;
    }

    if (Date.now() - dernierPassage < DELAI_ENTRE_PASSAGES) return;

    enCours = true;
    dernierPassage = Date.now();

    lirePanier()
      .then(function (cart) {
        var orphelines = trouverOrphelines(cart);
        var maintenant = Date.now();

        /* Une ligne redevenue rattachee sort de la liste des suspectes. */
        Object.keys(suspectes).forEach(function (cle) {
          if (orphelines.indexOf(cle) === -1) delete suspectes[cle];
        });

        if (!orphelines.length) { enCours = false; return; }

        /* Verrou 2 : deux observations distinctes, espacees. */
        var confirmees = [];
        orphelines.forEach(function (cle) {
          if (!suspectes[cle]) {
            suspectes[cle] = maintenant;
            return;
          }
          if (maintenant - suspectes[cle] >= DELAI_CONFIRMATION) confirmees.push(cle);
        });

        if (!confirmees.length) {
          enCours = false;
          programmerNouvellePasse(DELAI_CONFIRMATION + 200);
          return;
        }

        /* Verrou 3a : plafond de securite. */
        if (confirmees.length > PLAFOND_SUPPRESSION) {
          if (window.console && console.warn) {
            console.warn(
              '[mqh] ' + confirmees.length + ' options orphelines detectees : ' +
              'au-dela du plafond de ' + PLAFOND_SUPPRESSION + ', aucune suppression.'
            );
          }
          suspectes = {};
          enCours = false;
          return;
        }

        /* Verrou 3b : derniere lecture juste avant de detruire. */
        if (ecritureRecente()) {
          suspectes = {};
          enCours = false;
          programmerNouvellePasse(DELAI_APRES_ECRITURE);
          return;
        }

        return lirePanier().then(function (frais) {
          var encore = trouverOrphelines(frais);
          var aRetirer = confirmees.filter(function (cle) {
            return encore.indexOf(cle) !== -1;
          });

          if (!aRetirer.length || ecritureRecente()) {
            suspectes = {};
            enCours = false;
            return;
          }

          aRetirer.forEach(function (cle) { delete suspectes[cle]; });

          return retirer(aRetirer)
            .then(rafraichir)
            .then(function (ok) {
              enCours = false;
              /* si le redessin a echoue, on recharge : mieux vaut un
                 clignotement qu'un panier affichant des lignes disparues */
              if (!ok) window.location.reload();
            });
        });
      })
      .catch(function () { enCours = false; });
  }

  /* ==========================================================
     Vidage du panier
     ========================================================== */

  function brancherVidage() {
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var btn = e.target.closest('[data-mqh-cart-clear]');
      if (!btn) return;
      e.preventDefault();

      if (!window.confirm('Vider entierement votre panier ?')) return;

      btn.disabled = true;
      btn.textContent = 'Suppression...';

      fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(rafraichir)
        .then(function (ok) {
          if (!ok) window.location.reload();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = 'Vider le panier';
        });
    });
  }

  /* ==========================================================
     Demarrage
     ========================================================== */

  function demarrer() {
    programmerNouvellePasse(DELAI_APRES_ECRITURE);
    brancherVidage();

    if (demandeOuverture()) {
      if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('cart-drawer-component')
          .then(function () { essayerOuvrir(0); })
          .catch(function () { essayerOuvrir(0); });
      }
      essayerOuvrir(0);
    }

    /* le panier de Horizon se redessine sans recharger la page */
    ['cart:update', 'cart:refresh', 'cart:change'].forEach(function (nom) {
      document.addEventListener(nom, function () {
        programmerNouvellePasse(DELAI_APRES_ECRITURE);
      });
    });

    /* Observation ciblee sur le panier. « main » en dernier recours
       seulement : sur une fiche produit, il mute a chaque interaction
       du formulaire de personnalisation et reveillait le nettoyeur
       en pleine sequence d'ajout. */
    var cible = document.querySelector('cart-drawer-component, cart-items-component');
    if (cible && window.MutationObserver) {
      new MutationObserver(function () {
        programmerNouvellePasse(1000);
      }).observe(cible, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();